import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=fb3e07ba&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb3e07ba')) {
      api.createRecord('fb3e07ba', component.options)
    } else {
      api.reload('fb3e07ba', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=fb3e07ba&", function () {
      api.rerender('fb3e07ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23PjMbg106osw/JS/comp/ImgFallback.vue"
export default component.exports